/**
 * Home Callout Stats component
 */
const vHomeCalloutStats = () => {
	const homeCalloutStats 		  = document.querySelector( '.v-home-callout-stats' );
	const homeCalloutStatLogos = document.querySelectorAll( '.v-home-callout-stats__logo ' );

	if ( ! homeCalloutStats || homeCalloutStatLogos.length <= 5 ) { // Do not rotate logos if less than 5
		return;
	}

	let lastTime   = 0; // Keep track of the last execution time
	const interval = 5000;

	/**
	 * Rotate Logos
	 *
	 * @param currentTime
	 */
	const rotateLogos = ( currentTime ) => {
		if ( ! lastTime ) {
			lastTime = currentTime;
		}
		const elapsed = currentTime - lastTime;

		if ( elapsed > interval ) {
			const current = document.querySelector( '.current' );
			let next      = current.nextElementSibling;
			current.classList.remove( 'current' );
			if ( next ) {
				next.classList.add( 'current' );
			} else {
				next = document.querySelectorAll( '.v-home-callout-stats__logos' )[ 0 ];
				next.classList.add( 'current' );
			}

			// Update lastTime
			lastTime = currentTime;
		}
		requestAnimationFrame( rotateLogos );
	};
	requestAnimationFrame( rotateLogos );
};

export default vHomeCalloutStats;
